<template>
  <div>
    <SfModal v-e2e="'login-modal111'" :visible="isLoginModalOpen" class="modal">
      <template #close>
        <div></div>
      </template>
      <template #modal-bar>
        <SfBar class="sf-modal__bar" :close="true" :title="$t(barTitle)" style="color: black;"
          @click:close="closeModal()" />
      </template>
      <transition name="sf-fade" mode="out-in">
        <div v-if="currentScreen === SCREEN_LOGIN">
          <ValidationObserver v-slot="{ handleSubmit }" key="log-in">
            <form class="form" @submit.prevent="handleSubmit(handleLogin)" v-if="RegistrySettings">
              <SfTabs :openTab="LoginTab" @click:tab="changeLoginTab">
                <SfTab v-e2e="'login-modal-tab-email'" :title="$t('Login_tab_email')"
                  v-if="RegistrySettings.email.enable">
                </SfTab>
                <SfTab v-e2e="'login-modal-tab-mobile'" :title="$t('Login_tab_mobile')"
                  v-if="RegistrySettings.phone.enable">
                </SfTab>
              </SfTabs>
              <div v-if="LoginTab == 1 && RegistrySettings.email.enable">
                <ValidationProvider rules="required|email" v-slot="{ errors }">
                  <SfInput v-e2e="'login-modal-email'" v-model="form.username" :valid="!errors[0]"
                    :errorMessage="$t(errors[0])" name="email" :label="$t('Login_input_email')" class="form__element" />
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <SfInput v-e2e="'login-modal-password'" v-model="form.password" :valid="!errors[0]"
                    :errorMessage="$t(errors[0])" name="password" :label="$t('Login_input_password')" type="password"
                    class="form__element" />
                </ValidationProvider>
                <SfCheckbox v-e2e="'login-modal-remember-me'" v-model="rememberMe" name="remember-me"
                  :label="$t('Login_input_Remember')" class="form__element checkbox" />
                <div v-if="error.login" style="color: #f00;margin-bottom: 5px;">
                  {{ error.login }}
                </div>
                <SfButton v-e2e="'login-modal-submit'" type="submit" class="sf-button--full-width form__button"
                  :disabled="loading">
                  <SfLoader :class="{ loader: loading }" :loading="loading">
                    <div>{{ $t('Login') }}</div>
                  </SfLoader>
                </SfButton>
              </div>
              <div v-if="LoginTab !== 1 && RegistrySettings.phone.enable">
                <div style="font-size:0.8rem;color:#000;font-weight:500;margin-bottom:0.5rem;">{{ $t('Country') }}</div>
                <div style="display:flex">
                  <div>
                    <SfSelect :label="''" v-model="form.phone_country_code" name="country" class="countrySelect"
                      style="padding-top:0.8rem;">
                      <SfSelectOption v-for="ctry in country" :key="ctry.label" :value="ctry.value">{{ ctry.label }}
                      </SfSelectOption>
                    </SfSelect>
                  </div>
                  <div style="flex:1">
                    <ValidationProvider rules="required|mobile" v-slot="{ errors }">
                      <SfInput v-e2e="'login-modal-phone'" v-model="form.phone" :valid="!errors[0]"
                        :errorMessage="$t(errors[0])" name="phone" :label="$t('Login_input_mobile')"
                        class="form__element" />
                    </ValidationProvider>
                  </div>
                </div>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <SfInput v-e2e="'login-modal-password'" v-model="form.password" :valid="!errors[0]"
                    :errorMessage="$t(errors[0])" name="password" :label="$t('Login_input_password')" type="password"
                    class="form__element" />
                </ValidationProvider>
                <SfCheckbox v-e2e="'login-modal-remember-me'" v-model="rememberMe" name="remember-me"
                  :label="$t('Login_input_Remember')" class="form__element checkbox" />
                <div v-if="error.login" style="color: #f00;margin-bottom: 5px;">
                  {{ error.login }}
                </div>
                <SfButton v-e2e="'login-modal-submit'" type="submit" class="sf-button--full-width form__button"
                  :disabled="loading">
                  <SfLoader :class="{ loader: loading }" :loading="loading">
                    <div>{{ $t('Login') }}</div>
                  </SfLoader>
                </SfButton>
              </div>
            </form>
          </ValidationObserver>
          <div class="action" v-if="(RegistrySettings.email.enable || RegistrySettings.phone.enable)">
            <SfButton class="sf-button--text" @click="setCurrentScreen(SCREEN_FORGOTTEN)">
              {{ $t('Login_forgotten_password') }}
            </SfButton>
          </div>
          <div class="bottom" v-if="RegistrySettings.email.enable || RegistrySettings.phone.enable">
            <p class="bottom__paragraph">{{ $t('Login_no_account') }}</p>
            <SfButton class="sf-button--text" @click="setCurrentScreen(SCREEN_REGISTER)">
              {{ $t('Login_Register') }}
            </SfButton>
            <SfButton v-if="RegistrySettings.is_guest" class="sf-button--text" @click="gusetLogin()">
              {{ $t('guest_Login') }}
            </SfButton>
          </div>
        </div>
        <div v-else-if="currentScreen === SCREEN_FORGOTTEN">
          <p>{{ $t('Login_Forgot_Password') }}</p>
          <ValidationObserver v-slot="{ handleSubmit }" key="log-in">
            <form class="form" @submit.prevent="handleSubmit(handleForgotten)">
              <ValidationProvider rules="required|email" v-slot="{ errors }">
                <SfInput v-e2e="'forgot-modal-email'" v-model="form.username" :valid="!errors[0]"
                  :errorMessage="$t(errors[0])" name="email" :label="$t('Forgot Password Modal Email')"
                  class="form__element" />
              </ValidationProvider>
              <div v-if="forgotPasswordError.request">
                {{ forgotPasswordError.request.message }}
              </div>
              <SfButton v-e2e="'forgot-modal-submit'" type="submit" class="sf-button--full-width form__button"
                :disabled="forgotPasswordLoading">
                <SfLoader :class="{ loader: forgotPasswordLoading }" :loading="forgotPasswordLoading">
                  <div>{{ $t('Reset_Password') }}</div>
                </SfLoader>
              </SfButton>
            </form>
          </ValidationObserver>
          <div class="action">
            {{ $t('or') }}
            <SfButton class="sf-button--text" @click="setCurrentScreen(SCREEN_LOGIN)">
              {{ $t('login_logbtn') }}
            </SfButton>
          </div>
        </div>
        <div v-else-if="currentScreen === SCREEN_THANK_YOU" class="thank-you">
          <i18n tag="p" class="thank-you__paragraph" path="forgotPasswordConfirmation">
            <span class="thank-you__paragraph--bold">{{ userEmail }}</span>
          </i18n>
          <p class="thank-you__paragraph">{{ $t('Thank_You_Inbox') }}</p>
        </div>
        <div v-else-if="currentScreen === SCREEN_WECHAT_CODE">
          <div style="background:#fff;">
            <img :src="qr_code" style="width:70%;margin:auto;display: block;" />
          </div>
          <div class="action">
            {{ $t('or') }}
            <SfButton class="sf-button--text" @click="setCurrentScreen(SCREEN_LOGIN)">
              {{ $t('login_logbtn') }}
            </SfButton>
          </div>
        </div>
        <div v-else class="form">
          <ValidationObserver v-slot="{ handleSubmit }" key="sign-up" v-if="RegistrySettings">
            <SfTabs :openTab="LoginTab" @click:tab="changeLoginTab">
              <SfTab v-e2e="'login-modal-tab-email'" :title="$t('register_email')" v-if="RegistrySettings.email.enable">
              </SfTab>
              <SfTab v-e2e="'login-modal-tab-mobile'" :title="$t('register_mobile')"
                v-if="RegistrySettings.phone.enable">
              </SfTab>
            </SfTabs>
            <form class="form" @submit.prevent="handleSubmit(handleRegister)" autocomplete="off">
              <ValidationProvider v-if="LoginTab == 1" ref="emailValida" rules="required|email" v-slot="{ errors }">
                <div style="display: flex;">
                  <div style="flex:1">
                    <SfInput v-e2e="'login-modal-email'" v-model="form.email" :valid="!errors[0]"
                      :errorMessage="$t(errors[0])" name="email" :label="$t('Login_input_email')"
                      class="form__element" />
                  </div>
                </div>
              </ValidationProvider>
              <div style="display:flex" v-if="LoginTab != 1">
                <div>
                  <SfSelect :label="$t('Country')" v-model="form.phone_country_code" name="country"
                    class="countrySelect">
                    <SfSelectOption v-for="ctry in country" :key="ctry.label" :value="ctry.value">{{ ctry.label }}
                    </SfSelectOption>
                  </SfSelect>
                </div>
                <div style="flex:1">
                  <ValidationProvider ref="mobileValida" rules="required|mobile" v-slot="{ errors }">
                    <div style="display: flex;">
                      <div style="flex:1">
                        <SfInput v-e2e="'login-modal-mobile'" v-model="form.phone" :valid="!errors[0]"
                          :errorMessage="$t(errors[0])" name="mobile" :label="$t('Login_input_mobile')"
                          class="form__element" />
                      </div>
                    </div>
                  </ValidationProvider>
                </div>
              </div>
              <!--  v-if="(LoginTab == 1&&RegistrySettings.email.verify)||(LoginTab != 1&&RegistrySettings.phone.verify)" -->
              <div
                v-if="(LoginTab == 1 && RegistrySettings.email.verify) || (LoginTab != 1 && RegistrySettings.phone.verify)">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div style="display:flex">
                    <div style="flex:1">
                      <SfInput v-e2e="'login-modal-code'" v-model="form.code" :valid="!errors[0]"
                        :errorMessage="$t(errors[0])" name="first-code" :label="$t('Login_input_code')"
                        class="form__element" />
                    </div>
                    <div style="margin-left:2px;" v-if="LoginTab !== 1">
                      <SfButton v-e2e="'login-modal-send-code'" type="button" class="sf-button--full-width form__button"
                        :disabled="sendCodeLoading || jiaoyanPhone" @click="handleSendCode">
                        {{ sendCodeLoading ? $t('code.time', { time: codeDate }) : $t('mobile_code') }}
                      </SfButton>
                    </div>
                    <div style="margin-left:2px;" v-if="LoginTab == 1">
                      <SfButton v-e2e="'login-modal-send-code'" type="button" class="sf-button--full-width form__button"
                        :disabled="sendCodeLoading || jiaoyanEmail" @click="handleSendCode">
                        {{ sendCodeLoading ? $t('code.time', { time: codeDate }) : $t('mobile_code') }}
                      </SfButton>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <SfInput v-e2e="'login-modal-firstName'" v-model="form.firstName" :valid="!errors[0]"
                  :errorMessage="$t(errors[0])" name="first-name" :label="$t('Login_input_first')"
                  class="form__element" />
              </ValidationProvider>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <SfInput v-e2e="'login-modal-lastName'" v-model="form.lastName" :valid="!errors[0]"
                  :errorMessage="$t(errors[0])" name="last-name" :label="$t('Login_input_last')"
                  class="form__element" />
              </ValidationProvider>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <SfInput v-e2e="'login-modal-password'" v-model="form.password" :valid="!errors[0]"
                  :errorMessage="$t(errors[0])" name="password" :label="$t('Login_input_password')" type="password"
                  class="form__element" />
              </ValidationProvider>
              <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">
                <SfCheckbox v-e2e="'login-modal-create-account'" v-model="createAccount" :valid="!errors[0]"
                  :errorMessage="$t(errors[0])" name="create-account" class="form__element">
                  <template #label>
                    <SfButton style="margin-left:5px;" class="sf-button--text" @click="openRegstContext">{{ $t('Login_create_account') }}
                    </SfButton>
                  </template>
                </SfCheckbox>
              </ValidationProvider>
              <div v-if="error.register" style="color: #f00;margin-bottom:5px;">
                {{ error.register }}
              </div>
              <SfButton type="submit" class="sf-button--full-width form__button" :disabled="loading">
                <SfLoader :class="{ loader: loading }" :loading="loading">
                  <div>{{ $t('Login_Create') }}</div>
                </SfLoader>
              </SfButton>
            </form>
          </ValidationObserver>
          <div class="action">
            {{ $t('or') }}
            <SfButton class="sf-button--text" @click="setCurrentScreen(SCREEN_LOGIN)">
              {{ $t('login_logbtn') }}
            </SfButton>
          </div>
        </div>
      </transition>
      <div
        v-if="(currentScreen !== SCREEN_WECHAT_CODE && currentScreen !== SCREEN_THANK_YOU && currentScreen!= SCREEN_FORGOTTEN) && (RegistrySettings.email.enable || RegistrySettings.phone.enable)">
        <div class="footer__socials" v-if="config">
          <div>
            <SfButton v-for="item in social" :key="item" @click="handleAuthLogin(item)"
              style="width:100%;margin-bottom:10px;">
              <SfImage class="footer__social-image" style="margin: 0; margin-right: 0.7rem"
                :src="addBasePath('/icons/' + item + '.svg')" :alt="item" :width="32" :height="32" /> {{
              $t('Login_with_'
              +
              item) }}
            </SfButton>
          </div>
        </div>
      </div>
    </SfModal>
    <Modal ref="registerComponent" name="register" />
  </div>
</template>
<script>
import { ref, watch, reactive, computed, useContext, onUnmounted, onBeforeUnmount, useRouter } from '@nuxtjs/composition-api';
import { SfModal, SfInput, SfButton, SfCheckbox, SfLoader, SfAlert, SfBar, SfImage, SfTabs, SfSelect } from '@storefront-ui/vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import { useForgotPassword, useUser, useApiError, useVerify, useGuest } from '@bee-hole/coms';
import { useUiState } from '~/composables';
import { addBasePath } from '@vue-storefront/core';
import axios from 'axios';
import { useCustomerStore } from '~/stores/customer';
import Modal from '@/components/ContentModal/modal';
extend('email', {
  ...email,
  message: 'email_geshi_error',
  validate: value => {
    const emailRegxt =/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegxt.test(value);
  }
});
extend('mobile', {
  validate: value => {
    return /^1[3456789]\d{9}$/.test(value);
  },
  message: 'mobile_geshi_error'
});
extend('required', {
  ...required,
  message: 'Shipping_valid_required'
});
export default {
  name: 'LoginModal',
  components: {
    SfModal,
    SfInput,
    SfButton,
    SfCheckbox,
    SfLoader,
    SfAlert,
    ValidationProvider,
    ValidationObserver,
    SfBar,
    SfImage,
    SfTabs,
    SfSelect,
    Modal
  },
  setup(props, context) {
    // console.log('-----------context', context?.root);
    const router = useRouter();
    // const route = useRoute();
    const { set: setError } = useApiError();
    const { $config, $cookies } = useContext();
    const customerStore = useCustomerStore();
    const { login: guestLogin, guest, setToken } = useGuest();
    const { phoneVerify: sendYanzheng, emailVerify } = useVerify();
    // const { relationAdd, result: relationRes } = useRelation();
    const RegistrySettings = computed(() => context?.root?.$options?.$storeConfig?.mall_registry_settings || { email: { enable: false }, phone: { enable: false }, is_guest: false });
    const mobileValida = ref();
    const emailValida = ref();
    const country = ref([
      {
        value: 86,
        label: "(+86) 中国大陆"
      }, {
        value: 852,
        label: "(+852) 中国香港"
      }, {
        value: 886,
        label: "(+886) 中国台湾"
      }, {
        value: 853,
        label: "中国澳門 (+853)"
      }, {
        value: 49,
        label: '(+49) Deutschland'
      }, {
        value: 1,
        label: '(+1) United States'
      }, {
        value: 34,
        label: '(+34) España '
      }, {
        value: 33,
        label: '(+33) France'
      }, {
        value: 7,
        label: '(+7) Россия'
      }, {
        value: 65,
        label: "(+65) Singapore"
      }, {
        value: 39,
        label: '(+39) Italia'
      }, {
        value: 81,
        label: "(+81) 日本"
      }, {
        value: 351,
        label: 'Portugal (+351)'
      }, {
        value: 44,
        label: '(+44) United Kingdom'
      }, {
        value: 66,
        label: "(+66) ประเทศไทย"
      }, {
        value: 20,
        label: '(+20) ' + `مصر `
      }, {
        value: 880,
        label: '(+880) বাংলাদেশ'
      }, {
        value: 91,
        label: '(+91) भारत'
      }, {
        value: 82,
        label: '(+82) 대한민국'
      }
    ]);
    const sendCodeLoading = ref(false);
    const codeTimer = ref();
    const codeDate = ref();
    const SCREEN_LOGIN = 'login';
    const SCREEN_REGISTER = 'register';
    const SCREEN_THANK_YOU = 'thankYouAfterForgotten';
    const SCREEN_FORGOTTEN = 'forgottenPassword';
    const SCREEN_WECHAT_CODE = 'wechatCode';
    const LoginTab = ref(1);
    const { isLoginModalOpen, toggleLoginModal, isMobile } = useUiState();
    const form = ref({});
    const userEmail = ref('');
    const qr_code = ref('');
    const createAccount = ref(false);
    const rememberMe = ref(false);
    const social = ref([]);
    const loginTimer = ref(null);
    const list = ['google', 'microsoft', 'facebook', 'wechat'];
    const config = computed(() => {
      const config = context?.root?.$options?.$storeConfig;
      const icons = [];
      list.map((icon) => {
        if (config['mall_' + icon + '_login'] === '1') icons.push(icon);
      });
      social.value = icons;
      return icons;
    });
    const { register, login, loading, error: userError, load } = useUser();
    const { request, error: forgotPasswordError, loading: forgotPasswordLoading } = useForgotPassword();
    const currentScreen = ref(SCREEN_LOGIN);
    // const currentuseOauth = useOauth();
    const changeLoginTab = (index) => {
      LoginTab.value = index;
      form.value = {};
      if (LoginTab.value !== 1) {
        form.value.phone_country_code = '86';
      }
    };

    const error = reactive({
      login: null,
      register: null
    });
    const timeClear = () => {
      sendCodeLoading.value = false;
      form.value = {};
      if (loginTimer.value) {
        clearInterval(loginTimer.value);
      }
      if (codeTimer.value) {
        clearInterval(codeTimer.value);
      }
      if (LoginTab.value !== 1) {
        form.value.phone_country_code = '86';
      }
    };
    onUnmounted(() => {
      timeClear();
    });
    // 页面被卸载前
    onBeforeUnmount(() => {
      timeClear();
    });
    const resetErrorValues = () => {
      error.login = null;
      error.register = null;
    };

    const barTitle = computed(() => {
      switch (currentScreen.value) {
        case SCREEN_LOGIN:
          return 'Sign in';
        case SCREEN_REGISTER:
          return 'Register';
        case SCREEN_WECHAT_CODE:
          return 'wechat_code_login';
        default:
          return 'Reset_Password';
      }
    });

    watch(isLoginModalOpen, () => {
      if (isLoginModalOpen.value) {
        resetErrorValues();
        if (RegistrySettings.value?.email?.enable) {
          changeLoginTab(1);
        } else if (RegistrySettings.value?.phone?.enable) {
          changeLoginTab(2);
        }
      }
    });

    const setCurrentScreen = (screenName) => {
      resetErrorValues();
      currentScreen.value = screenName;
      if (screenName !== SCREEN_WECHAT_CODE) {
        clearInterval(loginTimer.value);
      }
      timeClear();
    };

    const handleForm = (fn) => async () => {
      resetErrorValues();
      await fn({ user: form.value, customQuery: { phone: form.value?.phone, phone_country_code: form.value?.phone_country_code } });

      const hasUserErrors = userError.value.register || userError.value.login;
      if (hasUserErrors) {
        error.login = userError.value.login?.message;
        error.register = userError.value.register?.message;
        return;
      }
      const token = context?.root?.$cookies?.get('token')
      const tokenkey = context?.root?.$cookies.get("tokenkey");
      if (tokenkey && !customerStore?.isSetToken && token) {
        await setToken({ key: tokenkey });
        customerStore.setisSetToken(true);
        // await getPrePayList({ user_id: $cookies.get('userKey') });
        // customerStore.setPrePayNum(prepaylist.value?.list?.length)
        // context?.root?.$cookies?.remove('tokenkey')
      }
      // const distcode = route.value.query.distributor_code;
      // if (token && distcode) {
      //   console.log('--------------------');
      //   await relationAdd({ distributor_code: distcode });
      // }
      toggleLoginModal();
      if (customerStore?.LoginPath === 'Shipping') {
        router.push(context.root.localePath('/my-account/Shipping'));
      } else if (customerStore?.LoginPath === 'order') {
        router.push(context.root.localePath('/checkout/shipping'));
      }
      window.location.reload()
    };

    const closeModal = () => {
      resetErrorValues();
      setCurrentScreen(SCREEN_LOGIN);
      toggleLoginModal();
      timeClear();

    };

    const handleRegister = async () => handleForm(register)();

    const handleLogin = async () => handleForm(login)();

    const handleForgotten = async () => {
      userEmail.value = form.value.username;
      await request({ customQuery: { email: userEmail.value, reset_entry_link: (window.location.origin + context.root.localePath('/ResetPassword')) } });
      if (!forgotPasswordError.value.request) {
        setCurrentScreen(SCREEN_THANK_YOU);
      }
    };
    const getKey = () => {
      function s4() {
        return Math.floor((1 + Math.random()) * 10000)
          .toString(16);
      }
      return s4() + s4() + s4() + s4() + (new Date().getTime() / 1000);
    };
    const getToken = (key) => {
      clearInterval(loginTimer.value);
      loginTimer.value = setInterval(async () => {
        axios.get($config.API_URL_WEB + '/oauth/wechat/check?auth_id=' + key).then(async (res) => {
          if (res.data?.data?.access_token) {
            $cookies.set('token', res.data?.data?.access_token, {
              path: '/',
              maxAge: 60 * 60 * 24 * 365,
              sameSite: 'lax'
            });
            clearInterval(loginTimer.value);
            closeModal();
            const tokenkey = context?.root?.$cookies.get("tokenkey");
            if (tokenkey && !customerStore?.isSetToken) {
              await setToken({ key: tokenkey });
              customerStore.setisSetToken(true);
            }
            await load();
            if (customerStore?.LoginPath === 'Shipping') {
              router.push(context.root.localePath('/my-account/Shipping'));
            } else if (customerStore?.LoginPath === 'order') {
              router.push(context.root.localePath('/checkout/shipping'));
            }
          }
        });
      }, 2000);
    };
    const handleAuthLogin = async (provider) => {
      // console.log('process.env===========', $config.API_URL_WEB, window, provider);
      const link = $config.API_URL_WEB + '/oauth/' + provider + '?return_url=' + encodeURIComponent(window.location.href);
      if (provider === 'wechat') {
        if (/MicroMessenger/i.test(window.navigator.userAgent)) {
          const link2 = link + '&from=' + encodeURIComponent('app') + '&auth_id=' + getKey();
          window.open(link2, '_self');
        } else if (isMobile.value) {
          setError({ message: context?.root?.$t('Please_Use_WeChat_login'), code: 500 });
          return false;
        } else {
          const locale = context?.root?.$cookies.get('vsf-locale');
          const domain = context?.root?.$cookies.get('domain');
          // // 查询店铺的语言
          if (axios.defaults && axios.defaults.headers && axios.defaults.headers.common && axios.defaults.headers.common.Cookie) {
            axios.defaults.headers.common.Cookie = `domain=${domain}; vsf-locale=${locale};`;
          }
          const key = getKey();
          const link2 = link + '&from=' + encodeURIComponent('web') + '&auth_id=' + key;
          axios.get(link2).then(res => {
            if (res?.data?.data?.qr_code) {
              const qr_code1 = res?.data?.data?.qr_code;
              // 弹窗显示qr_code 二维码
              qr_code.value = qr_code1;
              getToken(key);
              setCurrentScreen(SCREEN_WECHAT_CODE);
            }
          });
        }
      } else {
        window.open(link, '_self');
      }
      // window.open(link, '_self');
    };
    const handleSendCode = async () => {
      // console.log('发送验证', form.value);
      if (LoginTab.value !== 1 && !form.value.phone) {
        setError({ message: context?.root?.$t('Login_input_mobile_required'), code: 500 });
        return false;
      }
      if (LoginTab.value === 1 && !form.value.email) {
        setError({ message: context?.root?.$t('Login_input_email_required'), code: 500 });
        return false;
      }
      sendCodeLoading.value = true;
      codeDate.value = 30;
      // 发送验证码倒计时
      if (LoginTab.value !== 1) {
        await sendYanzheng({ phone: form.value.phone });
      } else {
        await emailVerify({ email: form.value.email });
      }
      codeTimer.value = setInterval(() => {
        codeDate.value--;
        if (codeDate.value <= 0) {
          clearInterval(codeTimer.value);
          sendCodeLoading.value = false;
        }
      }, 1000);
    };
    const handleCountryChange = () => {
      // form.value.code = country.value[index].value;
    };
    const jiaoyanPhone = computed(() => {
      return Boolean(mobileValida.value?.errors[0]);
    });
    const jiaoyanEmail = computed(() => {
      return Boolean(emailValida.value?.errors[0]);
    });
    const gusetLogin = async () => {
      await guestLogin();
      if (guest.value?.token) {
        const tokenkey = context?.root?.$cookies.get("tokenkey");
        if (tokenkey && !customerStore?.isSetToken && guest.value?.token) {
          await setToken({ key: tokenkey });
          customerStore.setisSetToken(true);
        }
        if (guest.value?.token) {
          await load();
        }
        if (customerStore?.LoginPath === 'Shipping') {
          router.push(context.root.localePath('/my-account/Shipping'));
        } else if (customerStore?.LoginPath === 'order') {
          router.push(context.root.localePath('/checkout/shipping'));
        }
        toggleLoginModal();
        // customerStore.setisSetToken(true);
      }
    };
    const registerComponent = ref();
    const openRegstContext = () => {
      registerComponent.value.openModalXieYi();
    };
    return {
      form,
      error,
      userError,
      loading,
      createAccount,
      rememberMe,
      isLoginModalOpen,
      toggleLoginModal,
      handleLogin,
      handleRegister,
      forgotPasswordError,
      forgotPasswordLoading,
      handleForgotten,
      closeModal,
      userEmail,
      barTitle,
      currentScreen,
      setCurrentScreen,
      SCREEN_LOGIN,
      SCREEN_REGISTER,
      SCREEN_THANK_YOU,
      SCREEN_FORGOTTEN,
      SCREEN_WECHAT_CODE,
      addBasePath,
      social,
      handleAuthLogin,
      config,
      qr_code,
      LoginTab,
      changeLoginTab,
      sendCodeLoading,
      handleSendCode,
      codeDate,
      country,
      handleCountryChange,
      mobileValida,
      jiaoyanPhone,
      emailValida,
      jiaoyanEmail,
      RegistrySettings,
      gusetLogin,
      openRegstContext,
      registerComponent
    };
  }
};
</script>

<style lang="scss" scoped>
.modal {
  --c-text: #111214;
  --modal-index: 9999999;
  --overlay-z-index: 99999;
  --input-label-color: #111214;
  --tabs-content-tab-padding: var(--spacer-2xs) 0 !important;
  @include for-mobile {
  --modal-transform: translate3d(0%, 0%, 0);
  }
  .sf-tabs__content__tab {
    padding: 0 0;
  }
  .sf-modal__container{
    @include for-mobile {
    --modal-height:100vh;
    --modal-width: 100vw;
    }
  }
}

.login-code-modal {
  --c-text: #111214;
  --modal-index: 99999999;
  --overlay-z-index: 999999;
}

.form {
  margin-top: var(--spacer-sm);

  &__element {
    margin: 0 0 var(--spacer-2xs) 0;
  }
}

.action {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: var(--spacer-xl) 0 var(--spacer-xl) 0;
  font: var(--font-weight--light) var(--font-size--base) / 1.6 var(--font-family--secondary);

  &>* {
    margin: 0 0 0 var(--spacer-xs);
  }
}

.action {
  margin: var(--spacer-xl) 0 var(--spacer-xl) 0;
}

.checkbox {
  margin-bottom: var(--spacer-sm);
}

.bottom {
  text-align: center;
  margin-bottom: var(--spacer-lg);
  font-size: var(--h3-font-size);
  font-weight: var(--font-weight--semibold);
  font-family: var(--font-family--secondary);

  &__paragraph {
    color: var(--c-primary);
    margin: 0 0 var(--spacer-base) 0;

    @include for-desktop {
      margin: 0;
    }
  }
}

.thank-you {
  &__paragraph {
    &--bold {
      font-weight: var(--font-weight--semibold);
    }
  }
}

.footer__socials {
  margin: 0 auto 0 !important;
  justify-content: center !important;
}

.sf-bar-code {
  z-index: 99999;
}</style>
<style lang="scss">
.modal {
  .sf-tabs__content__tab {
    --tabs-content-tab-padding: var(--spacer-sm) 0 0 0 !important;
  }
}

.countrySelect {
  .sf-select__dropdown {
    height: 33px;
    margin: 0;
    // font:var(--input-label-font, var(--input-label-font-weight, var(--font-weight--normal)) var(--input-label-font-size, var(--font-size--lg))/var(--input-label-font-line-height, 1) var(--input-label-font-family, var(--font-family--secondary)));
  }

  .sf-select__error-message {
    display: none;
  }
}
</style>
